import CognitoService from '../../Services/cognitoService'
import NotificationService from '../notificationService'
import template from './loginComponentTemplate'
import ScreenManagingService from "../screenManagingService";
import UserTokenManagementService from "../../Services/userTokenManagementService";
import {logoEncoded, userIcon, eyeIcon, eyeSlashIcon, signInIcon} from "./LoginComponentIcons";
import defaultConfigForCognito from "../../constants/cognitoConfig";
import CEGuidelineCognitoForgotPassword from "../ForgotpasswordComponent/forgotPasswordComponent.js";
import CEGuidelineCognitoResetPassword from "../ResetPasswordComponent/resetPasswordComponent.js";
import CEGuidelineModal from "../ModalComponent/modalComponent.js";
import SessionManagementService from "../../Services/sessionManagementService";
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import sanitizeForLog from "../../helpers/sanitizeLog";

const uiAnalyticsFlag = 'DisableUIAnalytics';
export default class CEGuidelineCognitoLogin extends HTMLElement {
    constructor() {
        super();

        // Prevent user from going back from login page
        window.history.forward();
        history.pushState(null, document.title, location.href);
        window.addEventListener('popstate', function (event) {
            history.pushState(null, document.title, location.href);
        });

        this._apiUrl = null;
        this._cognitoConfig = null;
        this._sessionManagementService = new SessionManagementService();
        this.registerCustomElements();
        this.orgList = {};

        this._loginErrorMessage = 'Login failed. Please check your credentials and try again.';
        this.attachShadow({mode: 'open'});
        this.shadowRoot.innerHTML = template;
        this.tokenManagement = new UserTokenManagementService();
        this.notification = new NotificationService(this.shadowRoot);
        this.screen = new ScreenManagingService(this.shadowRoot);
        this.shadowRoot.querySelector('#login-form-submit').addEventListener('click', this.onLogin.bind(this));
        this.shadowRoot.querySelector('#email-submit').addEventListener('click', this.onSubmitEmail.bind(this));
        this.shadowRoot.querySelector('#email').addEventListener('input', this.handleEmailInput.bind(this))
        this.shadowRoot.querySelector('#eye-icon-button').addEventListener('click', this.onClickShowPassword.bind(this));
        this.shadowRoot.querySelector('#org-submit').addEventListener('click', this.handleSubmit.bind(this));
        this.shadowRoot.querySelector('#sendVerificationCode').addEventListener('click', this.showSendVerificationCodeForm.bind(this));
        this.shadowRoot.querySelector('#password').addEventListener('input', this.updateSignInButtonState.bind(this));
        this.shadowRoot.querySelector('#copy-email-btn').addEventListener('click', this.onCopyEmail.bind(this));
        this.shadowRoot.querySelector('#change-email').addEventListener('click', (e) => {
            e.preventDefault();
            this.showEmailForm();
        });
        this.addIcons();
    }

    registerCustomElements() {
        window.customElements.get('ce-guideline-forgot-password') || window.customElements.define('ce-guideline-forgot-password', CEGuidelineCognitoForgotPassword);
        window.customElements.get('ce-guideline-reset-password') || window.customElements.define('ce-guideline-reset-password', CEGuidelineCognitoResetPassword);
        window.customElements.get('ce-guideline-modal') || window.customElements.define('ce-guideline-modal', CEGuidelineModal);
    }


    get apiUrl() {
        return this._apiUrl;
    }

    set apiUrl(value) {
        this._apiUrl = value;
    }

    get cognitoConfig() {
        return this._cognitoConfig;
    }

    set cognitoConfig(value) {
        if (this._cognitoConfig !== value) {
            this._cognitoConfig = value;
            this._cognito = new CognitoService(this._cognitoConfig);
            this.setCognitoToForgotComponent();
            this.setCognitoToResetComponent();
        }
    }

    get cognito() {
        return this._cognito;
    }

    isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    async handleSubmit(e) {
        e.preventDefault();
        const selectedOrg = this.shadowRoot.querySelector('#organization-select').value;
        this.details.selectedOrg = selectedOrg;
        const response = await fetch(`${this.apiUrl}/configuration/organization/${selectedOrg}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${this.details.idToken}`,
                'x-org-id':selectedOrg,
                'x-org': selectedOrg,
                'Content-Type': 'application/json'
            }});
        const data = await response.json();
        if (data?.payload?.settings) {
            const settings = data?.payload?.settings.find(item => item.name === uiAnalyticsFlag)
            if (settings) {
                this.details.uiAnalytics = settings.value?.toLowerCase() === 'false'? 'true': 'false';
            } else {
                this.details.uiAnalytics = true;
            }
        }
        this.dispatchEvent(new CustomEvent("onLogin", {
            detail: {...this.details}
        }));

    }

    handleEmailInput() {
        const submitButton = this.shadowRoot.querySelector('#email-submit');
        const emailInput = this.shadowRoot.querySelector('#email');

        // If the email is valid, enable the submit button, otherwise disable it
        if (this.isValidEmail(emailInput.value)) {
            submitButton.disabled = false;
        } else {
            submitButton.disabled = true;
        }
    }

    updateSignInButtonState() {
        const username = this.shadowRoot.querySelector('#username').value;
        const password = this.shadowRoot.querySelector('#password').value;
        this.shadowRoot.querySelector('#login-form-submit').disabled = !username || !password;
    }

    showLoginForm() {
        this.shadowRoot.querySelector('#login-form-federated').style.display = 'none';
        this.shadowRoot.querySelector('#login-form-organization-select').style.display = 'none';
        this.shadowRoot.querySelector('#forgotPasswordForm').style.display = 'none';
        this.shadowRoot.querySelector('#resetPasswordForm').style.display = 'none';
        this.shadowRoot.querySelector('#no-organization').style.display = 'none';
        this.shadowRoot.querySelector('#login-form').style.display = 'block';
        this.shadowRoot.querySelector('#email-chip-text').textContent = this.shadowRoot.querySelector('#username').value;
        this.updateSignInButtonState();
    }

    showEmailForm() {
        this.shadowRoot.querySelector('#login-form').style.display = 'none';
        this.shadowRoot.querySelector('#login-form-federated').style.display = 'block';
        this.shadowRoot.querySelector('#username').value = '';
        this.shadowRoot.querySelector('#email-chip-text').textContent = '';
        this.shadowRoot.querySelector('#password').value = '';
        this.shadowRoot.querySelector('#error-message').style.display = 'none';
    }

    showOrganizationSelectForm() {
        this.shadowRoot.querySelector('#login-form-federated').style.display = 'none';
        this.shadowRoot.querySelector('#login-form-organization-select').style.display = 'block';
        this.shadowRoot.querySelector('#login-form').style.display = 'none';
        this.shadowRoot.querySelector('#forgotPasswordForm').style.display = 'none';
        this.shadowRoot.querySelector('#resetPasswordForm').style.display = 'none';
    }

    showSendVerificationCodeForm() {
        this.shadowRoot.querySelector('#login-form-federated').style.display = 'none';
        this.shadowRoot.querySelector('#login-form').style.display = 'none';
        this.shadowRoot.querySelector('#login-form-organization-select').style.display = 'none';
        this.shadowRoot.querySelector('#resetPasswordForm').style.display = 'none';
        this.shadowRoot.querySelector('#forgotPasswordForm').style.display = 'block';
    }

    showResetPasswordForm() {
        this.shadowRoot.querySelector('#login-form-federated').style.display = 'none';
        this.shadowRoot.querySelector('#login-form').style.display = 'none';
        this.shadowRoot.querySelector('#login-form-organization-select').style.display = 'none';
        this.shadowRoot.querySelector('#forgotPasswordForm').style.display = 'none';
        this.shadowRoot.querySelector('#resetPasswordForm').style.display = 'block';
    }

    addIcons() {
        // add icons
        const logoImage = this.shadowRoot.querySelector('#logoImage');
        //  const logoImage2 = this.shadowRoot.querySelector('#logoImage2');
        const userImage = this.shadowRoot.querySelector('#user-icon');
        const eyeImage = this.shadowRoot.querySelector('#eye-icon');
        const signInImage = this.shadowRoot.querySelector('#sign-in-icon');

        userImage.setAttribute('src', userIcon);
        logoImage.setAttribute('src', logoEncoded);
        //logoImage2.setAttribute('src', logoEncoded);
        eyeImage.setAttribute('src', eyeIcon);
        signInImage.setAttribute('src', signInIcon);
    }

    async onSubmitEmail(e) {
        e.preventDefault();

        const email = this.shadowRoot.querySelector('#email').value;
        this.shadowRoot.querySelector('#username').value = email;

        const response = await fetch(`${this.apiUrl}/auth/login-option`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email
            })
        });
        const data = await response.json()
        const domain = data.payload.loginOptionName;

        if (domain !== 'Default') {
            localStorage.setItem('federatedSignIn', true); // needed to show loader when return from federated signin
            return this._cognito.federatedSignIn(domain).then((data)=>{
            }).catch(error => {
                this.showLoginForm()
                // Handle error (e.g., display error message to user)
            });
        } else {
            this.showLoginForm()
        }
    }

    async onGetAvailableOrganizationsList(authToken) {
        localStorage.removeItem('federatedSignIn');

        this.showOrganizationSelectForm();
        this.screen.showLoader();
        const response = await fetch(`${this.apiUrl}/me/organization/list`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json'
            }});
        const data = await response.json();
        const organisationList = data.payload;
        this.orgList = {};
        if (organisationList.length) {
            this.screen.hideLoader();

            const selectElement = this.shadowRoot.querySelector('#organization-select');

// Clear any existing options
            selectElement.innerHTML = '';

// Iterate over the payload and create options
            organisationList.forEach(org => {
                const option = document.createElement('option');
                option.value = org.orgId;
                option.className = 'option-select-org';
                option.textContent = org.orgName;
                selectElement.appendChild(option);
                this.orgList[org.orgId] = org.orgName
            });
            this.details.orgList = JSON.stringify(this.orgList)

        } else {
          this.shadowRoot.querySelector("#org-submit").disabled = true;
          this.shadowRoot.querySelector("#no-organization").style.display = "block";
        }
    }

    async onGetAvailableOrganizationsListSSO(authToken, user) {
        localStorage.removeItem('federatedSignIn');
        // Amplify v6: Use fetchAuthSession to get tokens
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        const accessToken = session.tokens?.accessToken?.toString();
        const refreshToken = this.getRefreshTokenFromStorage();
        this.details = {
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken,
            defaultRedirectEnv: `${defaultConfigForCognito.defaultRedirectEnv}/access-redirect`,
            selectedOrg: null,
            loginError: null,
        }
        this.showOrganizationSelectForm();
        this.orgList = {};

        const response = await fetch(`${this.apiUrl}/me/organization/list`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json'
            }});
        const data = await response.json();
        const organisationList = data.payload;
        if (organisationList.length) {
            const selectElement = this.shadowRoot.querySelector('#organization-select');

            selectElement.innerHTML = '';

            organisationList.forEach(org => {
                const option = document.createElement('option');
                option.value = org.orgId;
                option.className = 'option-select-org';
                option.textContent = org.orgName;
                this.orgList[org.orgId] = org.orgName
                selectElement.appendChild(option);
            });
            this.details.orgList = JSON.stringify(this.orgList)
        } else {
            this.shadowRoot.querySelector("#org-submit").disabled = true;
            this.shadowRoot.querySelector("#no-organization").style.display = "block";
        }
    }
    getRefreshTokenFromStorage() {
        // Amplify v6 stores refresh token in localStorage with this key pattern
        const clientId = this._cognitoConfig?.userPoolWebClientId || defaultConfigForCognito.userPoolWebClientId;
        const lastAuthUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
        const lastAuthUser = localStorage.getItem(lastAuthUserKey);
        
        if (lastAuthUser) {
            const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastAuthUser}.refreshToken`;
            return localStorage.getItem(refreshTokenKey) || '';
        }
        return '';
    }

    async signInUser(user) {
        // Amplify v6: Use fetchAuthSession to get tokens
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        const accessToken = session.tokens?.accessToken?.toString();
        const refreshToken = this.getRefreshTokenFromStorage();

        // DO we need to store token in token manager?
        this.tokenManagement.addUserIDToken(idToken);
        this.details = {
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken,
            defaultRedirectEnv: `${defaultConfigForCognito.defaultRedirectEnv}/access-redirect`,
            selectedOrg: null,
            loginError: null,
        }

        this.onGetAvailableOrganizationsList(idToken);
        this.notification.hideLoader();
    }

    async onLogin(e) {
        e.preventDefault();
        this.screen.showLoader();

        const modal = this.shadowRoot.querySelector('#custom-modal');

        const username = this.shadowRoot.querySelector('#username').value?.toLowerCase();
        const password = this.shadowRoot.querySelector('#password').value;
        this.screen.hideAllScreens();
        
        try {
            const signInResult = await this._cognito.signInUser(username, password, true);
            
            // Amplify v6: Check for NEW_PASSWORD_REQUIRED challenge
            if (signInResult && signInResult.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
                this.setUserNameToResetComponent(signInResult);
                this.showResetPasswordForm();
                this.notification.hideLoader();
                return;
            }
            
            // If sign in is complete, get the session and user info
            if (signInResult && signInResult.isSignedIn) {
                const session = await fetchAuthSession();
                const idToken = session.tokens?.idToken?.toString();
                
                // Parse JWT to get user attributes
                const userAttributes = this._cognito.parseJwt(idToken);
                
                // for qa automation users multiple sessions are allowed
                if (userAttributes["custom:qa_automation"] != 1) {
                    try {
                        await this.checkIfUserHasPreviousSession(idToken);
                        await this.signInUser(signInResult);
                    } catch (data) {
                        // If user canceled the modal, just show login form without closing sessions
                        this.screen.showLoginForm();
                        this.notification.hideLoader();
                    }
                } else {
                    await this.signInUser(signInResult);
                }
            } else {
                this.notification.hideLoader();
            }
        } catch (e) {
            const error = String(e);
            if (error.includes('username or password you entered is incorrect') || error.includes('NotAuthorizedException')) {
                this._loginErrorMessage = 'We\'re sorry, the username or password you entered is incorrect.';
            }
            if (error.includes('Max attempts have')) {
                this._loginErrorMessage = 'We\'re sorry, the username or password you entered is incorrect. Max attempts have been reached. Please reach out to your administrator.';
            }
            this.screen.hideLoader();
            this.screen.showLoginForm();
            this.notification.showErrorMessage(this._loginErrorMessage);
            this.notification.hideLoader();
        }
    }

    checkIfUserHasPreviousSession(token) {
        return new Promise((resolve, reject) => {
            this.screen.showLoader();
            this._sessionManagementService.hassPreviousSessions(token).then((data) => {
                this.screen.hideLoader();
                if (data.payload.hasPreviousSessions) {
                    const modal = this.shadowRoot.querySelector('#custom-modal');
                    modal.show(
                        'All active sessions will be closed. Do you want to continue?',
                        () => {
                            this._sessionManagementService.invalidatePreviousSessions(token).then(() => {
                                resolve();
                            })},
                        () => {
                            return Promise.allSettled([
                                this.invalidateCurrentSession(token),
                                this._cognito.signOutCurrentSession()
                            ]).then((results) => {
                                results.forEach((r) => {
                                    if (r.status === 'rejected') console.error('Session cancel cleanup error:', sanitizeForLog(r.reason));
                                });
                                reject({token: token});
                            });
                        }
                    );
                } else {
                    resolve();
                }
            }).catch((error) => {
                this.screen.hideLoader();
                resolve();
            });
        });

    }

    onLoginWithSSO(e) {
        e.preventDefault();
        return this._cognito.signInUserWithSSO();
    }

    invalidateCurrentSession(token) {
        return  this._sessionManagementService.invalidateCurrentSession(token).then(
            () => {
                console.log("Session invalidated");
            },
            (error) => {
                console.log("Error invalidating session", sanitizeForLog(error));
            }
        );
    }
    invalidatePreviousSessions(token) {
        return  this._sessionManagementService.invalidatePreviousSessions(token).then(
            () => {
                console.log("Session invalidated");
            },
            (error) => {
                console.log("Error invalidating session", sanitizeForLog(error));
            }
        );
    }

    async logOutUser(data) {
        try {
            // Show loading state and hide screens
            this.screen.showLoader();
            this.screen.hideAllScreens();

            // Clean up browser state
            this._cognito.performLogoutCleanup();
            this.tokenManagement.removeUserIDToken();

            // Invalidate session and sign out
            await this.invalidatePreviousSessions(data?.token);
            await this.invalidateCurrentSession(data?.token);
            await this._cognito.signOutUser();

            // Prevent user from going back after logout
            window.history.forward();
            history.pushState(null, document.title, location.href);

            // Return to login form

        } catch (error) {
            console.log('Error during logout:', error);
            this.screen.showLoginForm(); // Show login form even on error
        } finally {
            this.notification.hideLoader();
        }
    }

    async logOutUserWithoutReload() {
        try {
            // Show loading state and hide screens
            this.notification.showLoader();
            const returnUrl = window.localStorage.getItem('returnUrl');

            const idToken = this._cognito.getIdTokenFromCookies();
            // Invalidate session and sign out

            await this.invalidatePreviousSessions(idToken);
            await this.invalidateCurrentSession(idToken);
            // signOutUser is the single owner of the logoutReturnUrl key: it cleans up
            // storage/cookies, persists logoutReturnUrl BEFORE Amplify's signOut (which itself
            // redirects hosted-UI/SSO sessions), and redirects. Do NOT write logoutReturnUrl
            // here or run performLogoutCleanup() after it — an early write stores the literal
            // string "null" when returnUrl is absent, and a late cleanup wipes the key before
            // the redirect commits (MT-23471).
            this.tokenManagement.removeUserIDToken();
            await this._cognito.signOutUser(returnUrl);

            // Return to login form

        } catch (error) {
            console.log('Error during logout:', error);
            this.notification.hideLoader();
        }
    }

    onCopyEmail() {
        const copyBtn = this.shadowRoot.querySelector('#copy-email-btn');
        const copyIcon = this.shadowRoot.querySelector('#copy-icon');
        const checkIcon = this.shadowRoot.querySelector('#check-icon');
        navigator.clipboard.writeText('help@guideline.ai').then(() => {
            copyIcon.style.display = 'none';
            checkIcon.style.display = 'block';
            copyBtn.classList.add('copied');
            setTimeout(() => {
                copyIcon.style.display = 'block';
                checkIcon.style.display = 'none';
                copyBtn.classList.remove('copied');
            }, 2000);
        });
    }

    onClickShowPassword(e) {
        const passwordInput = this.shadowRoot.querySelector("#password"),
            eyeIconElement = this.shadowRoot.querySelector("#eye-icon");
        passwordInput.type = passwordInput.type === "password" ? "text" : "password";
        eyeIconElement.setAttribute('src', passwordInput.type === "password" ? eyeIcon : eyeSlashIcon);
    }

    setCognitoToForgotComponent() {
        const forgotPasswordComponent = this.shadowRoot.querySelector('ce-guideline-forgot-password');
        if (forgotPasswordComponent) {
            forgotPasswordComponent.cognito = this._cognito;
        }
    }

    setCognitoToResetComponent() {
        const resetPasswordComponent = this.shadowRoot.querySelector('ce-guideline-reset-password');
        if (resetPasswordComponent) {
            resetPasswordComponent.cognito = this._cognito;
        }
    }

    setUserNameToResetComponent(user) {
        const resetPasswordComponent = this.shadowRoot.querySelector('ce-guideline-reset-password');
        if (resetPasswordComponent) {
            resetPasswordComponent.user = user;
            // After a successful reset, confirmSignIn has already authenticated this user with the
            // new password. Carry that freshly-verified session straight into the org-selection
            // screen instead of logging out and forcing a re-login (MT-23529).
            resetPasswordComponent.onResetComplete = () => this.signInUser();
        }
    }
}

// window.customElements.define('ce-guideline-cognito-login', CEGuidelineCognitoLogin);